import React from 'react';

function BankingRigthTab() {


    return (
        <div className="">
            잘못된 주소 접근입니다.
        </div>

    );
}

export default BankingRigthTab;